import { COMPANY_INFO } from "@/lib/companyInfo";

/**
 * Draws a unified company header on a jsPDF document:
 *   [ LOGO ]   Associated Building Specialties, Inc.
 *              1785 W. 160th Ave. Suite 400, Broomfield, CO 80023
 *              303-293-2096  |  service@absinc.com
 *
 * Logo on the left, company info vertically centered to the right of the logo.
 * Returns the Y position just after the header (for the caller to continue rendering).
 */
export function addCompanyHeader(doc, startY = 12) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 14;
  const logoW = 28;
  const logoH = 18;
  const headerH = logoH + 2;

  // Logo (top-left)
  try {
    const logoImg = new Image();
    logoImg.src = "/abs-logo.png";
    doc.addImage(logoImg, "PNG", margin, startY, logoW, logoH);
  } catch { /* fallback: no logo */ }

  // Company info — vertically centered relative to the logo
  const infoLines = [
    { text: COMPANY_INFO.name, size: 11, bold: true, color: [30, 41, 59] },
    { text: COMPANY_INFO.fullAddress || COMPANY_INFO.address || "", size: 8, bold: false, color: [100, 100, 100] },
    { text: `${COMPANY_INFO.phone}  |  ${COMPANY_INFO.email}`, size: 8, bold: false, color: [100, 100, 100] },
  ];
  const lineH = 4;
  const totalTextH = infoLines.length * lineH;
  let textY = startY + (logoH - totalTextH) / 2 + lineH; // center-align text block with logo
  const textX = margin + logoW + 6;

  infoLines.forEach((ln) => {
    doc.setFontSize(ln.size);
    doc.setFont(undefined, ln.bold ? "bold" : "normal");
    doc.setTextColor(ln.color[0], ln.color[1], ln.color[2]);
    doc.text(ln.text, textX, textY);
    textY += lineH;
  });

  // Thin separator line
  const sepY = startY + headerH + 2;
  doc.setDrawColor(203, 213, 225); // slate-300
  doc.setLineWidth(0.3);
  doc.line(margin, sepY, pageWidth - margin, sepY);

  // Reset defaults for caller
  doc.setFont(undefined, "normal");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);

  return sepY + 5; // Y below the separator where caller should continue
}
